import React, {PureComponent} from 'react'
import {connect} from 'react-redux'

import * as actions from '../../store/actions/actions'

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import Header from "../../components/Headers/Header";
import {
    Alert,
    Button,
    Card,
    CardBody,
    CardHeader,
    Col,
    Container, FormGroup, Input,
    Modal,
    ModalBody, ModalFooter,
    ModalHeader,
    Row
} from "reactstrap";
import { withLocalize } from "react-localize-redux";
import { Translate } from "react-localize-redux";
import "./file.css";
import NumberFormat from 'react-number-format';

import italianFilePlickTranslations from "../../translations/file/plick/it.file.plick.json";
import englishFilePlickTranslations from "../../translations/file/plick/en.file.plick.json";


const RemotePagination = ({ data, columns,page, sizePerPage, onTableChange, totalSize,rowClasses,pageStartIndex }) => (
    <div>
        <BootstrapTable bootstrap4
            classes="table-responsive align-items-center table-flush"
            headerClasses="thead-light"
            rowClasses={rowClasses}
            remote
            keyField="id"
            data={ data }
            columns={ columns }
            pagination={ paginationFactory({ page, sizePerPage, totalSize ,pageStartIndex}) }
            onTableChange={ onTableChange }
        />
        {/*<Code>{ sourceCode }</Code>*/}
    </div>
);


class Plick extends PureComponent {
  constructor(props) {
    super(props);

    this.props.addTranslationForLanguage(italianFilePlickTranslations, "it");
    this.props.addTranslationForLanguage(englishFilePlickTranslations, "en");
  }

  onBackClick = () => {
    this.props.history.goBack();
  }

  onDetailClick = (plickId) => {
      let bankId=this.props.fileBankId;
    let data = {
      "fileId": this.props.history.location.pathname.split('/')[2],
      "plickId": plickId,
        "bankId":bankId
    }
    this.props.fetchPlickDetail(data)
  }

    handleTableChange = (type,  {page, sizePerPage} ) => {
      let pageChangeRequest={file:this.props.fileId,bankId:this.props.fileBankId,page:page,size:sizePerPage}
      this.props.changePagePlicks(pageChangeRequest)
    }

    toggleCorrectionModal = () => {
        this.props.toggleCorrectionModal()
    }


  render() {

      let correctionModal =
          <Modal className="modal-dialog modal-lg"
                 isOpen={this.props.hasCorrectionModal}
                 presentationStyle="fullScreen"
                 toggle={this.toggleCorrectionModal}>
              <ModalHeader toggle={this.toggleCorrectionModal}></ModalHeader>
              <ModalBody>
                  <div className="pl-lg-12">
                      <Row>
                          <Col lg="12">
                              <Translate id="plick.correctionModal.body"/>
                          </Col>
                      </Row>
                  </div>
              </ModalBody>
              <ModalFooter>
                  <Row>
                      <Button color="primary" onClick={this.toggleCorrectionModal}>
                          <Translate id="plick.correctionModal.button.continue"/>
                      </Button>
                  </Row>
              </ModalFooter>
          </Modal>

      let totalElements=this.props.totalElements;
      let page=this.props.page;
      let size=this.props.sizePerPage;
      const columns = [
          {
              text: <Translate id="file.plick.plick.detail"/> ,
              align: 'center',
              events: {
                  onClick: (e, column, columnIndex, row, rowIndex) => {
                      this.onDetailClick(row.id,row.idBank)
                  }
              },
              formatter:(cellContent, row) => (
                  <Button size="sm">
                      <i className="fas fa-user-edit text-primary" />
                  </Button>
              )
          },
          {text: <Translate id="file.plick.transaction.id"/>, dataField: 'transactionId'},
          {text: <Translate id="file.plick.sender.id"/>, dataField: 'senderId'},
          {text: <Translate id="file.plick.sender.company"/>, dataField: 'senderCompany'},
          {text: <Translate id="file.plick.sender.device"/>, dataField: 'senderDevice'},
          {text: <Translate id="file.plick.sender.account"/>, dataField: 'senderAccount'},
          {text: <Translate id="file.plick.sender.language.preferences"/>, dataField: 'senderLanguagePreferences'},
          {text: <Translate id="file.plick.sender.extra.info.name"/>, dataField: 'senderExtraInfoName'},
          {text: <Translate id="file.plick.receiver.name"/>, dataField: 'receiverName'},
          {text: <Translate id="file.plick.receiver.device"/>, dataField: 'receiverDevice'},
          {text: <Translate id="file.plick.receiver.iban"/>, dataField: 'receiverIban'},
          {text: <Translate id="file.plick.receiver.iban.from.bank"/>, dataField: 'receiverIbanFromBank'},
          {text: <Translate id="file.plick.bank.id"/>, dataField: 'idBank'},
          {text: <Translate id="file.plick.activation.date"/>, dataField: 'activationDate'},
          {text: <Translate id="file.plick.amount"/>,
              formatter: (cellContent, row) => (
                <NumberFormat value={row.amount}
                  displayType={'text'}
                  thousandSeparator={'.'}
                  decimalSeparator={','}
                  suffix={' €'} />)
          },
          {text: <Translate id="file.plick.causal"/>, dataField: 'causal'},
          {text: <Translate id="file.plick.notes"/>, dataField: 'notes'},
          {text: <Translate id="file.plick.pin"/>, dataField: 'pin'},
          {text: <Translate id="file.plick.pin.type"/>, dataField: 'pinType'},
          {text: <Translate id="file.plick.logo.id"/>, dataField: 'idLogo'},
      ]
      const rowEvents = {
          scope:"row"
      };
      const rowClasses = (row, rowIndex) => {
          if(row.correctPlick===false){
              return 'validationError';
          }

      };
      let table = this.props.plicks === null ? null :
          // <BootstrapTable bootstrap4
          //                 headerClasses="thead-light"
          //                 classes="table-responsive align-items-center table-flush"
          //                 keyField='id'
          //                 data={ this.props.plicks }
          //                 columns={ columns }
          //                 pagination={ paginationFactory() } rowEvents={ rowEvents }
          //                 rowClasses={rowClasses}
          // />
          // <BootstrapTable
          //     remote
          //     keyField="id"
          //     data={ this.props.plicks }
          //     columns={ columns }
          //     pagination={ paginationFactory({ page, size, totalElements }) }
          //     onTableChange={ this.handleTableChange(size,page,size) }
          // />
          <RemotePagination
              data={ this.props.plicks }
              columns={columns}
              page={ page }
              sizePerPage={ size }
              onTableChange={ this.handleTableChange }
              totalSize={ totalElements }
              rowClasses={rowClasses}
              pageStartIndex={0}
          />

    return (
        <>
            <Header />
            <Container className="mt--5" fluid>
                {/* Table */}
                <Row>
                    <div className="col" style={{paddingBottom:"2%"}}>
                        <Card className="shadow">
                            <CardHeader className="border-0">
                                <Row>
                                    <div className="col">
                                        <h3 className="mb-0">
                                          <Translate id="file.plick.campaign.plicks"/>
                                        </h3>
                                    </div>
                                </Row>
                            </CardHeader>
                            <CardBody>
                            {table}
                            {correctionModal}
                                <Row style={{paddingTop:"2%"}}>
                                  <Col align="left">
                                    <Button onClick={this.onBackClick} variant="contained">
                                      <i className="fas fa-arrow-left text-primary" />
                                    </Button>
                                  </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </div>
                </Row>
            </Container>
        </>
    );
  }
}

const mapStateToProps = state => {
  return {
      plicks: state.plick.plicks,
      fileId: state.plick.fileId,
      totalElements: state.plick.totalElements,
      page: state.plick.page,
      fileBankId:state.plick.fileBankId,
      sizePerPage:state.plick.sizePerPage,
      hasCorrectionModal: state.plick.hasCorrectionModal
  }
}

const mapDispatchToProps = dispatch => {
  return {
      toggleCorrectionModal: () => dispatch({type: actions.TOGGLE_CORRECTION_MODAL }),
      fetchPlickDetail: (plickData) => dispatch({ type: actions.FETCH_PLICK_DETAIL_REQUEST, value: plickData }),
      changePagePlicks: (pageChangeRequest) => dispatch({ type: actions.FETCH_PLICKS_PAGE_REQUEST, value: pageChangeRequest })
  };
};

export default withLocalize(connect(mapStateToProps, mapDispatchToProps)(Plick));